import React, { useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { user as userVar } from 'apollo/cache';
import { matchPath } from 'react-router-dom';
import { BETA_PATH } from 'utility/constants';
import { ENABLE_BETA } from 'config';

const BetaContext = React.createContext(undefined);

const BetaContextProvider = ({ children }) => {
  const user = useReactiveVar(userVar);
  const role = []
  const [isBeta, setIsBeta] = useState(false);
  const [isUsedBeta, setIsUsedBeta] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isFristFoundBeta, setIsFristFoundBeta] = useState(false);

  
useEffect(() => {
  if (role && ENABLE_BETA === "true") {
    const isRoleBeta = role.includes('m0-beta');
    role && setIsBeta(role.includes('m0-beta'));
    const path = window.location.pathname + window.location.search
    const match = matchPath(window.location.pathname, {
      path: BETA_PATH,
    });
    // ถ้ามีการเปิดใช้งาน beta แล้วแต่ไม่ได้เข้า path ที่เป็น version beta ให้ route กับไปที่ version beta
    if (isRoleBeta && user?.useBeta === true && !match) {
      window.location.href = BETA_PATH + path;
    }
    // ยังไม่ได้เปิดใช้งาน beta แตเข้า path ที่เป็น version beta
    else if (user?.useBeta !== true && match) {
      window.location.href = (path.replace(
        BETA_PATH,
        ''
      )) || "/"
    }
    // Role ไม่สามารถใช้งาน beta ได้ แต่ path เป็น version beta
    else if (!isRoleBeta && match) {
      window.location.href = (path.replace(
        BETA_PATH,
        ''
      )) || "/"
    } else if(isRoleBeta && match && user?.useBeta === true) {
      setIsUsedBeta(true);
      setIsInitialized(true);
    }else{
      setIsInitialized(true);
    }
  } else {
    setIsInitialized(true);
  }
}, [role]);

  useEffect(() => {
    const storage = JSON.parse(localStorage.getItem('isFrist'));
    if (storage?.foundBeta !== true) {
      setIsFristFoundBeta(true);
      localStorage.setItem(
        'isFrist',
        JSON.stringify({
          ...storage,
          foundBeta: true,
        })
      );
    }
  }, []);

  const store = {
    isBeta,
    isUsedBeta,
    setIsUsedBeta,
    isFristFoundBeta,
    setIsFristFoundBeta
  };
  return (
    <BetaContext.Provider value={store}>{isInitialized ? children : <div />}</BetaContext.Provider>
  );
};

export { BetaContext, BetaContextProvider };
